import { FC, useState } from "react";
import { useSound } from "../../../../hooks";
import slotMachineLeverSprint from "../../../../assets/images/slotMachineLeverSpring.png";

interface WheelHandleButtonProps {
    clickHandler():void;
    disabled: boolean;
}

const WheelHandleButton: FC<WheelHandleButtonProps> = ({clickHandler, disabled}) => {
    const [ toggleLever, setToggleLever ] = useState<boolean>(false);
    const {playSound} = useSound();

    const handleClick =  () => {
        if (!disabled) {
            clickHandler()
            playSound("/sounds/LeverPull.mp3");
        } 
            
        setToggleLever(true);

        setTimeout(() => {
            setToggleLever!(false);
        }, 1000 );
    }
    
    return(
        <div className="slot_machine_spin_lever_wrapper center_horizontally_and_vertically" >
            <div className="s_m_lever_image_wrapper" onClick={handleClick}>
                <img 
                    className={`stop_picture_dragging ${toggleLever ? "s_m_lever_sprint_image_animated" : "s_m_lever_sprint_image"}`} 
                    src={slotMachineLeverSprint} 
                    alt="lever" 
                />
            </div>
        </div>
    )
}

export default WheelHandleButton;